
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-select-all.html
riot.tag2('menu-item-select-all',
  '<svg if="{parent.menuName === ⁗region-menu⁗}" class="floating-menu_icon"> <use xlink:href="#select-all-icon"></use> </svg> <span class="floating-menu_label">{selectAllText()}</span>',
  '',
  'class="floating-menu_item {\'floating-menu_item--iconless\': parent.menuName !== \'region-menu\'} {opts.classes}" onclick="{selectElements}"', function(opts) {
'use strict';

var _this = this;

var _selectionUi = require('lib/selection-ui');

var canvas = this.parent.opts.canvas;

this.selectAllText = function () {
  if (_this.parent.singleCardMenu) {
    return 'Select all in this card';
  }
  if (_this.parent.menuName === 'region-menu') {
    return 'Select all in region';
  }
  return 'Select all';
};

this.selectElements = function (e) {
  var elementTags = [];
  if (_this.parent.nodeTag) {
    elementTags = _this.selectAllInCard();
  } else if (_this.parent.menuName == 'region-menu') {
    elementTags = _this.selectAllInRegion();
  } else {
    elementTags = _this.selectAll();
  }

  _this.parent.hide();
};

this.selectAll = function () {
  var elementTags = [];
  for (var _iterator = canvas.store.getNodes(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var node = _ref;

    if (canvas.nodeTags[node.id]) {
      elementTags.push(canvas.nodeTags[node.id]);
    }
  }
  for (var _iterator2 = canvas.store.getLinks(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref2 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref2 = _i2.value;
    }

    var link = _ref2;

    if (canvas.linkTags[link.id]) {
      elementTags.push(canvas.linkTags[link.id]);
    }
  }
  canvas.setSelectedElements(elementTags);
};

this.selectAllInCard = function () {
  var elementTags = [];
  var parentId = null;
  if (_this.parent.singleCardMenu) {
    parentId = _this.parent.nodeTag.id;
  }
  for (var _iterator3 = canvas.store.getNodes(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
    var _ref3;

    if (_isArray3) {
      if (_i3 >= _iterator3.length) break;
      _ref3 = _iterator3[_i3++];
    } else {
      _i3 = _iterator3.next();
      if (_i3.done) break;
      _ref3 = _i3.value;
    }

    var node = _ref3;

    if (canvas.nodeTags[node.id]) {
      if (parentId && node.parentId && node.parentId == parentId) {
        elementTags.push(canvas.nodeTags[node.id]);
      }
    }
  }
  canvas.setSelectedElements(elementTags);
};

this.selectAllInRegion = function () {
  var regionTag = _this.parent.regionTag;
  if (!regionTag) return [];
  _selectionUi.selectionUI.resetNodeRects();
  _selectionUi.selectionUI.selectAllInsideBox(regionTag.instance);
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-select-all')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-select-all.html
// module id = 705
// module chunks = 0